import {ModelApi} from '@/api/model.api.js'
import {Enrollment} from '@/models/enrollment.model.js'

/**
 * My enrollments API service
 */
export class MyEnrollmentsApi extends ModelApi {

  //Props
  basePath = '/my_enrollments'
  itemKey = 'enrollment'
  itemsKey = 'enrollments'
  ModelClass = Enrollment

  /**
   * Enroll by code
   */
  enrollByCode(message) {
    return this
      .post('/start', {message})
      .then(json => this.toModelInstance(json))
  }

  /**
   * Start or stop an enrollment
   */
  startOrStopEnrollment(enrollmentId) {
    return this
      .post(`/${enrollmentId}/start_or_stop_enrollment`)
      .then(json => this.toModelInstance(json))
  }

  /**
   * Resend last message
   */
  resendLastMessage(enrollmentId) {
    return this
      .post(`/${enrollmentId}/resend_last_message`)
      .then(json => this.toModelInstance(json))
  }

  /**
   * Submit feedback
   */
  submitFeedback(enrollmentId, feedback) {
    return this
      .post(`/${enrollmentId}/submit_feedback`, {[this.itemKey]: {feedback}})
      .then(json => this.toModelInstance(json))
  }
}

//Export singleton instance
export const myEnrollmentsApi = new MyEnrollmentsApi()
